// 按钮圆角
export const button = {
    large: 4,
    medium: 4,
    small: 4,
    mini: 3,
    mini_s: 2,
    mini_xs: 2
};
